<button
  mat-icon-button
  [matTooltip]="'Bring to front'"
  [intercomTarget]="'toolbar-context-menu-bring-to-front'"
  (click)="bringToFront.emit()"
>
  <fa-icon [icon]="['fal', 'bring-forward']" class="text-[14px]"></fa-icon>
</button>
<button
  mat-icon-button
  [matTooltip]="'Send to back'"
  [intercomTarget]="'toolbar-context-menu-send-to-back'"
  (click)="sendToBack.emit()"
>
  <fa-icon [icon]="['fal', 'send-backward']" class="text-[14px]"></fa-icon>
</button>
